import Component from './core/Component';
import { ObserverType } from './core/observer';
import GameObject from './core/GameObject';
import System from './core/System';
import Transform from './core/Transform';
import Game, { LOAD_SCENE_MODE } from './game/Game';
import Scene from './game/Scene';
import { IDEProp } from './decorators/ide';
import { componentObserver } from './decorators/system';
import {
  resource,
  LOAD_EVENT,
  RESOURCE_TYPE,
  RESOURCE_TYPE_STRATEGY,
  resourceLoader,
  normalizeResourceSrc,
  normalizeSpritesheetData,
} from './loader/Resource';

/** Decorators util */
const decorators = {
  IDEProp,
  componentObserver,
};

// for typescript
export type { PluginStruct, GameParams } from './game/Game';
export type {
  CombosGamePluginInitSuccessMessage,
  CombosGameReadyMessage,
  CombosGameStateChangedMessage,
  CombosGameSetPlayingMessage,
} from './game/bootstrapMessages';
export {
  COMBOS_GAME_PLUGIN_INIT_SUCCESS,
  COMBOS_GAME_READY,
  COMBOS_GAME_SET_PLAYING,
  COMBOS_GAME_STATE_CHANGED,
  postParentPluginInitSuccess,
  postParentGameReady,
  postParentGameState,
  parseSetPlayingMessage,
} from './game/bootstrapMessages';
export {
  DEFAULT_ALLOWED_MESSAGE_HOST_SUFFIXES,
  isAllowedMessageOrigin,
  mergeAllowedMessageOrigins,
} from './game/messageOrigin';
export type { TransformParams } from './core/Transform';
export type { ObserverEvent as ComponentChanged } from './core/ComponentObserver';
export type { PureObserverInfo } from './core/observer';
export type { UpdateParams, ComponentParams } from './core/Component';
export type { ObserverInfo } from './decorators/system';
export type { ResourceBase, PixiSpritesheetData, NormalizedSrcSlot } from './loader/Resource';
export type { SystemConstructor } from './core/System';

import { version } from './version';
console.log(`@combos-fun/engine version: ${version}`);

export {
  version,
  Game,
  Scene,
  GameObject,
  Component,
  System,
  Transform,
  resource,
  decorators,
  LOAD_EVENT,
  RESOURCE_TYPE,
  ObserverType as OBSERVER_TYPE,
  LOAD_SCENE_MODE,
  IDEProp,
  componentObserver,
  RESOURCE_TYPE_STRATEGY,
  resourceLoader,
  normalizeResourceSrc,
  normalizeSpritesheetData,
};